import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";

import Context from "./Context/UserContext";
import Context2 from "./Context/moviePopUpContext";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
const stripePromise = await loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const options = {
  mode: 'payment',
  amount: 1099,
  currency: 'usd',
  appearance: {
    theme: 'stripe',
    labels: 'floating',
  },
  layout: {
    type: 'tabs',
    defaultCollapsed: false,
  },
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Context>
        <Context2>
          <Elements stripe={stripePromise} options={options}>

            <App />
          </Elements>
        </Context2>
      </Context>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
